import * as React from 'react';
import { inject as mobxInject } from 'mobx-react';
import { AppStore } from '../stores/App.store';
import { NotificationStore } from '../components/Notification/Notification.store';
import { Omit } from '../types/global-types';

type IReactComponent<P> = React.FunctionComponent<P> | React.ComponentClass<P>;

export class RootStore<T = NotificationStore> {
  appStore: AppStore;
  notificationStore: T;

  constructor(appStore: AppStore, notificationStore: T) {
    this.appStore = appStore;
    this.notificationStore = notificationStore;
  }
}

export const withInjectedRootStore = <T>(
  WrappedComponent: IReactComponent<T>,
): IReactComponent<Omit<T, 'rootStore'>> =>
  mobxInject('rootStore')(WrappedComponent) as any;
